export const socialMediaLinks = {
    facebook: 'https://www.facebook.com/profile.php?id=61563119281020',
    youtube: 'https://www.youtube.com/@EnduroConnection-RadusaBosnien',
    instagram: 'https://www.instagram.com/enduro_connection_radusa/',
    tiktok: 'https://www.tiktok.com/@enduro_connection_radusa',
} as const;
